export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/ff34d6d8f50a-tooliconplaneticket.jpg',
  },
  title: 'What was your flight number?',
}
